import { rpcApi } from "@/api/rpc";
import { profileApi } from "@/api/profile";
import { clearAuth } from "@/store/slices/authSlice";
import type { AppDispatch } from "@/store";
import type { Session } from "@/types/profile";
import type { NavigateOptions } from "react-router-dom";

interface LogoutOptions {
  userId?: string;
  sessions?: Session[];
  dispatch: AppDispatch;
  navigate: (path: string, options?: NavigateOptions) => void;
}

export const handleLogout = async ({ userId, sessions, dispatch, navigate }: LogoutOptions) => {
    try {
      let currentSession = sessions?.find(s => s.is_current);

      if (!currentSession) {
        const { sessions: fetchedSessions } = await profileApi.getUserData();
        currentSession = fetchedSessions.find(s => s.is_current);
      }

      await rpcApi.logout("current", userId, currentSession?.id);
    } catch (err) {
      console.error("Logout API failed", err);
    } finally {
      dispatch(clearAuth());
      navigate("/", { replace: true });
    }
  };
